import React, { useEffect } from "react";
import { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//imported
import PrivateRoute from "./PrivateRoute";

import "../Assets/css/style.css";
import * as Path from "./paths";
import Login from "pages/AuthPages/Login/Index";
import AuthLayout from "layout/AuthLayout/AuthLayout";
import NonAuthLayout from "layout/NonAuthLayout/NonauthLayout";
import Dashboard from "pages/SideTabs/Dashboard/Index";
import MyClients from "pages/SideTabs/MyClients/Index";
import AddNewClient from "pages/SideTabs/AddNewClient/Index";
import ClientDetail from "pages/SideTabs/MyClients/Detail/Index";
import Research from "pages/SideTabs/Research/Index";
import Appointment from "pages/SideTabs/Appointment/Index";
import MyDocs from "pages/SideTabs/Docs&Forms/MyDocs/Index";
import MyForm from "pages/SideTabs/Docs&Forms/MyForms/Index";
import MyResources from "pages/SideTabs/Docs&Forms/Resources/Index";
import MyAccount from "pages/SideTabs/MyAccount/Index";
import SignUp from "pages/AuthPages/SignUp/Index";
import TermsCondition from "pages/SideTabs/TermsCondition/Index";
import TermsConditions from "pages/SideTabs/TermsConditions/Index";
import PrivacyPolicy from "pages/SideTabs/PrivacyPolicy/Index";
import Subscription from "pages/SideTabs/Subscription/Index";
import SubscriptionPayment from "pages/SideTabs/Subscription/Payment/Index";
import SubscriptionSuccess from "pages/SideTabs/SubscriptionSuccess/Index";
import EditForm from "pages/SideTabs/Docs&Forms/MyForms/Edit/Index";
import ForgotPassword from "pages/AuthPages/ForgotPassword/Index";

// import OTP from "pages/AuthPages/Otp/Index";
import VerifyOTP from "pages/AuthPages/VerifyOtp/Index";
import ResetPassword from "pages/AuthPages/ResetPassword/Index";
import Layout from "layout/Layout/Layout";

import MyFormPreview from "pages/SideTabs/Docs&Forms/MyForms/Component/FormListing/Components/formPreview";
import TodoReports from "pages/Mobile/TodoReports";
import MobileLayout from "layout/MobileLayout/MobileLayout";
import PackageDetail from "pages/SideTabs/MyAccount/Component/TabContent/MyPackage/PackageDetail/Index";
import DocumentStorage from "pages/SideTabs/DocumentStorage/Index";
import UpgradeDocumentStorage from "pages/SideTabs/DocumentStorage/UpgradeStorage/Index";
import ExportData from "pages/Export/Index";
import ClientMessaging from "pages/SideTabs/ClientMessaging/Index"
import EmailPreferences from "pages/EmailPreferences/Index";

// const Appointment = lazy(() => import("./pages/SideTabs/Appointment/Index"));

function routes({ isAuthenticated }) {
  return (
    <>
      {/* <Suspense fallback={<div>Loading...</div>}> */}
      <Routes>
        <Route element={isAuthenticated ? <NonAuthLayout /> : <AuthLayout />}>
          {isAuthenticated ? (
            <>
              <Route index element={<Navigate to={Path.dashboard} />} />
              <Route index path={Path.dashboard} element={<Dashboard />} />
              <Route path={Path.dashboardSubscription} element={<Subscription />} />
              <Route path={Path.subscriptionSuccess} element={<SubscriptionSuccess />} />
              <Route path={Path.dashboardSubscriptionPayment} element={<SubscriptionPayment />} />
              <Route path={Path.dashboardTermsCondition} element={<TermsCondition />} />
              <Route path={Path.privacyPolicy} element={<PrivacyPolicy />} />
              <Route path={Path.termsConditions} element={<TermsConditions />} />
              <Route path={Path.addClient} element={<AddNewClient />} />
              <Route path={Path.myClients} element={<MyClients />} />
              <Route path={Path.myClientDetails} element={<ClientDetail pageTitle="Client Details"/>} />
              <Route path={Path.foodResearch} element={<Research />} />
              <Route path={Path.appointment} element={<Appointment />} />
              <Route path={Path.myDocs} element={<MyDocs />} />
              <Route path={Path.myForms} element={<MyForm />} />
              <Route path={Path.addNewForm} element={<EditForm />} />
              <Route path={Path.editForm} element={<EditForm />} />
              <Route path={Path.resources} element={<MyResources />} />
              <Route path={Path.myAccount} element={<MyAccount />} />
              <Route path={Path.myFormsPreview} element={<MyFormPreview />} />
              <Route path={Path.packageDetails} element={<PackageDetail />} />
              <Route path={Path.documentStorage} element={<DocumentStorage />} />
              <Route path={Path.upgradeDocumentStorage} element={<UpgradeDocumentStorage />} />

              {/* Client messaging */}
              <Route path={Path.clientMessaging} element={<ClientMessaging />} />

              {/* Default route */}
              <Route path="*" element={<Navigate to={Path.dashboard} />} />
            </>
          ) : (
            <>
              <Route index element={<Navigate to={Path.login} />} />
              <Route path={Path.login} element={<Login />} />
              <Route path={Path.signup} element={<SignUp />} />
              <Route path={Path.forgotPassword} element={<ForgotPassword />} />
              <Route path={Path.verifyOTP} element={<VerifyOTP />} />
              <Route path={Path.resetPassword} element={<ResetPassword />} />

              {/* Default route */}
              <Route path="*" element={<Navigate to={Path.login} />} />
            </>
          )}
        </Route>
        {/* Mobile App Routes */}
        <Route element={<MobileLayout />}>
          <Route path={Path.mobileTodoReports} element={<TodoReports />} />
        </Route>

        {/* Route for user data export */}
        <Route path={Path.exportData} element={<ExportData />} />

        {/* Route for manage email preferences */}
        <Route path={Path.emailPreferences} element={<EmailPreferences />} />

        <Route path={Path.defaultRoute} element={<h1>Page not found:(</h1>} />
      </Routes>
      {/* </Suspense> */}
    </>
  );
}

const mapStateToPros = (state) => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(routes);
